import * as React from 'react';
import './time-picker.scss';
import { ReactComponent as ClockIcon } from '../../../assets/icons/icon_clock.svg';
import { ReactComponent as DashIcon } from '../../../assets/icons/dash.svg';

interface Props {
    setData: Function;
}

const TimePicker: React.FC<Props> = ({ setData }) => {
    const today = new Date();
    const time = ('0' + today.getHours()).slice(-2) + ':' + ('0' + today.getMinutes()).slice(-2);
    const [timeRange, setTimeRange] = React.useState<any>({
        startTime: time,
        endTime: time,
    });

    const handleFormData = (event: any) => {
        setTimeRange((values: any) => ({ ...values, [event.target.name]: event.target.value }));
        setData(timeRange)
    };

    return (
        <div className="time-picker-component__time-range">
            <div className="time-picker-component__icon-left">
                <ClockIcon />
            </div>

            <input
                className="time-picker-component__input"
                name="startTime"
                type="time"
                onChange={handleFormData}
                value={timeRange.startTime}
            />
            <div className="time-picker-component__dash-icon">
                <DashIcon />
            </div>
            <div className="time-picker-component__icon-right">
                <ClockIcon />
            </div>
            <input
                className="time-picker-component__input-right"
                name="endTime"
                type="time"
                onChange={handleFormData}
                value={timeRange.endTime}
            />
        </div>
    );
};
export default TimePicker;
